import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  tableRow: {
    borderBottom: `1px solid ${colors.neutral[300]}`,
    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  tableCell: {
    font: { size: '1.6rem', lineHeight: '2.4rem' },
    color: colors.neutral[900],
    letterSpacing: '0.02rem',
    padding: '1.6rem 1rem',
    '&:first-child': {
      paddingLeft: '2.4rem',
      width: '8rem',
    },
    '&:nth-child(2)': {
      width: '5rem',
    },
    '&:last-child': {
      paddingRight: '2.4rem',
    },
  },
  tag: {
    lineHeight: '2rem',
    textAlign: 'center',
    color: colors.neutral[900],
    verticalAlign: 'middle',
    padding: '0.4rem 0rem',
    borderRadius: '14px',
    fontSize: '1.2rem',
    width: '12rem',
  },
  tagType_NEW: { backgroundColor: colors.green[300] },
  tagType_VALIDATING: { backgroundColor: colors.yellow[300] },
  tagType_VALIDATION_ISSUES: { backgroundColor: colors.orange[300] },
  tagType_VALIDATION_DONE: { backgroundColor: colors.blue[300] },
  tagType_PROCESSING: { backgroundColor: colors.purple[300] },
  tagType_DONE_ISSUES: { backgroundColor: colors.red[600], color: colors.neutral.white },
  tagType_DONE_FULLY: { backgroundColor: colors.indigo[600], color: colors.neutral.white },
};

const createStyles = createUseStyles(styles);
export { createStyles };
